import GridPageAbstract from '../../abstract/GridPageAbstract';
// component
import { Divider, MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { currencyConfig } from '../../../config/currency.config';
import { ShowKeysDialog } from '../../dialogs/ShowKeysDialog';
import CommissionDialog from '../../dialogs/CommissionsDialog/CommissionsDialog';
import CreateTransactionDialog from '../../dialogs/CreateTransactionDialog';
import AddIcon from '@mui/icons-material/Add';
import { Archive } from '@mui/icons-material';
import React from 'react';
import TransferBalanceDialog from '../../dialogs/TransferBalanceDialog';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

const paymentHead = [
    {
        id: 'amount',
        label: 'amount',
        cell: 'Amount',
        type: 'number',
        default: 0
    },
    {
        id: 'description',
        label: 'description',
        cell: 'Text',
        default: ''
    },
    {
        id: 'email',
        label: 'email',
        cell: 'Text',
        default: ''
    },
    {
        id: 'phone',
        label: 'phone',
        cell: 'Text',
        default: ''
    },
    {
        id: 'payer_name',
        label: 'payer_name',
        cell: 'Text',
        default: ''
    }
];
const payoutHead = [
    {
        id: 'amount',
        label: 'amount',
        cell: 'Amount',
        type: 'number',
        default: 0
    },
    {
        id: 'description',
        label: 'description',
        cell: 'Text',
        default: ''
    },
    {
        id: 'email',
        label: 'email',
        cell: 'Text',
        default: ''
    },
    {
        id: 'phone',
        label: 'phone',
        cell: 'Text',
        default: ''
    },
    {
        id: 'card',
        label: 'card',
        cell: 'Text',
        default: ''
    },
    {
        id: 'payee_name',
        label: 'payee_name',
        cell: 'Text',
        default: ''
    },
    {
        id: 'bank',
        label: 'bank',
        cell: 'Text',
        default: ''
    },
    {
        id: 'payout_method',
        label: 'payout_method',
        cell: 'Text',
        default: ''
    }
];

export default class MerchantTerminalsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicMerchantTerminals';
        this.Server =
            this.props.context.getState().server.publicMerchantTerminals;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'name',
            'merchant.name',
            'merchantTerminalUuid',
            'ecomCascadeRule.name',
            'p2pCascadeRule.name',
            'payoutCascadeRule.name',
            'redirectCascadeRule.name'
        ];
        // this.showTotalRow = true;
        this.exportButton = true;

        this.paymentHead = paymentHead;

        this.payoutHead = payoutHead;
        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'merchantTerminalUuid',
                label: 'merchantTerminalUuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'State',
                items: ['approved', 'pending', 'rejected', 'deleted'],
                displayGrid: true
            },
            {
                id: 'merchantId',
                label: 'merchant',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'merchant',
                displayGrid: true,
                from: 'publicMerchants'
            },
            {
                id: 'merchantUrl',
                label: 'merchantUrl',
                alignRight: false,
                cell: 'Url',
                displayGrid: true
                // displayDialogDetails: true,
                // details: 'Json'
            },
            {
                id: 'kassirSecureDomain',
                label: 'kassirSecureDomain',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'kassirLinkDomain',
                label: 'kassirLinkDomain',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'apiKey',
                label: 'apiKey',
                alignRight: false,
                cell: 'Text',
                displayDialogDetails: true,
                details: 'Json',
                disableEditor: true
            },
            {
                id: 'ipWhitelist',
                label: 'ipWhitelist',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'currency',
                label: 'currency',
                alignRight: false,
                cell: 'Items',
                type: 'currency',
                noTranslate: true,
                items: Object.keys(currencyConfig),
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'signKey',
                label: 'signKey',
                alignRight: false,
                cell: 'Text',
                displayDialogDetails: true,
                details: 'Json',
                disableEditor: true
            },
            {
                id: 'totalBalance',
                label: 'totalBalance',
                alignRight: false,
                cell: 'Amount',
                // total: true,
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'totalAvailableBalance',
                label: 'totalAvailableBalance',
                alignRight: false,
                cell: 'Amount',
                // total: true,
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'settlementPeriod',
                label: 'settlementPeriod',
                alignRight: false,
                cell: 'Number',
                type: 'number',
                displayGrid: true
            },
            {
                id: 'ecomCascadeRuleId',
                label: 'ecomCascadeRule',
                alignRight: false,
                cell: 'ServerSearch',
                searchController: 'publicCascadeRules',
                searchFields: ['name'],
                show: 'name',
                object: 'ecomCascadeRule',
                displayGrid: true
            },
            {
                id: 'p2pCascadeRuleId',
                label: 'p2pCascadeRule',
                alignRight: false,
                cell: 'ServerSearch',
                searchController: 'publicCascadeRules',
                searchFields: ['name'],
                show: 'name',
                object: 'p2pCascadeRule',
                displayGrid: true
            },
            {
                id: 'payoutCascadeRuleId',
                label: 'payoutCascadeRule',
                alignRight: false,
                cell: 'ServerSearch',
                searchController: 'publicCascadeRules',
                searchFields: ['name'],
                show: 'name',
                object: 'payoutCascadeRule',
                displayGrid: true
            },
            {
                id: 'redirectCascadeRuleId',
                label: 'redirectCascadeRule',
                alignRight: false,
                cell: 'ServerSearch',
                searchController: 'publicCascadeRules',
                searchFields: ['name'],
                show: 'name',
                object: 'redirectCascadeRule',
                displayGrid: true
            },
            {
                id: 'isTrusted',
                label: 'isTrusted',
                alignRight: false,
                cell: 'Checkbox',
                type: 'boolean',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            },
            {
                id: 'p2pMethods',
                label: 'p2pMethods',
                alignRight: false,
                disableEditor: true,
                displayGrid: false,
                displayDialogDetails: true,
                details: 'Array'
            }
            // {
            //     id: 'FileId',
            //     label: 'file',
            //     cell: 'Upload',
            //     object: 'file',
            //     fileType: 'merchant',
            //     fileParent: 'id',
            // },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            openCommissionsDialog: false,
            showKeysDialogOpen: false,
            createTransactionDialogOpen: false,
            createTransactionHead: [],
            createTransactionTitle: '',
            createTransactionServer: null,
            merchantTerminalId: null,
            transferBalanceDialogOpen: false,
            transferBalanceMode: 'search',
            defaultFromId: null,
            defaultToId: null
        };
    }

    customLogicOnMount() {
        this.fs.clearGroup('prefilterBase')
            .addFilter('isArchived', '!=', true, 'prefilterBase', true);
    }

    handleShowCommissions(event) {
        this.handleCloseMenu();
        this.setState({
            openCommissionsDialog: true,
            merchantTerminalId: this.state.menuClickItemId
        });
    }

    handleCloseCommissions(event) {
        this.setState({
            openCommissionsDialog: false,
            merchantTerminalId: null
        });
    }

    renderCustomMenuItems() {
        const isAllowedCommissionPermission = this.allowedPermission(
            'read',
            'publicCommissions'
        );
        const isAllowedShowKeysAction = this.allowedAction('show-keys');
        const isAllowedCreatePayment = this.allowedAction(
            'create-payment-order'
        );
        const isAllowedCreatePayout = this.allowedAction('create-payout-order');
        const isItemArchived =
            this.getMenuClickItemValue('isArchived') === true;

        const isAllowedArchive = this.allowedArchive() && !isItemArchived;
        // const isAllowedTransferBalance = this.allowedTransferBalance();
        const menuItems = [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>
        ];

        if (isAllowedCommissionPermission) {
            menuItems.push(
                <MenuItem
                    key="showCommissions"
                    onClick={(event) => this.handleShowCommissions(event)}
                >
                    <InfoIcon sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.showCommissions')}
                </MenuItem>
            );
        }

        if (isAllowedShowKeysAction) {
            menuItems.push(
                <MenuItem
                    key="showKeys"
                    onClick={(event) => this.handleShowKeys(event)}
                >
                    <InfoIcon sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.showKeys')}
                </MenuItem>
            );
        }

        if (isAllowedArchive) {
            menuItems.push(
                <MenuItem
                    key="archive"
                    onClick={() => this.handleArchiveConfirmDialogOpen()}
                >
                    <Archive sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.archive')}
                </MenuItem>
            );
        }

        if (isAllowedCreatePayment) {
            menuItems.push(<Divider key="divider-create-paym" />);
            menuItems.push(
                <MenuItem
                    key="createPayment"
                    onClick={(event) => this.handleOpenCreatePayment(event)}
                >
                    <AddIcon sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.createPayment')}
                </MenuItem>
            );
        }

        if (isAllowedCreatePayout) {
            menuItems.push(
                <MenuItem
                    key="createPayout"
                    onClick={(event) => this.handleOpenCreatePayout(event)}
                >
                    <AddIcon sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.createPayout')}
                </MenuItem>
            );
            menuItems.push(<Divider key="divider-transf" />);
        }

        // if (isAllowedTransferBalance) {
        //     menuItems.push(
        //         <MenuItem
        //             key="transferBalanceFrom"
        //             onClick={() => {
        //                 this.setState({
        //                     merchantTerminalId: this.state.menuClickItemId
        //                 });
        //                 this.transferBalance('defaultFromId');
        //                 this.handleCloseMenu();
        //             }}
        //         >
        //             <ArrowBack sx={{ mr: 2, width: '20px' }} />
        //             {i18n.t('common.transferBalanceFrom')}
        //         </MenuItem>
        //     );
        //
        //     menuItems.push(
        //         <MenuItem
        //             key="transferBalanceTo"
        //             onClick={() => {
        //                 this.setState({
        //                     merchantTerminalId: this.state.menuClickItemId
        //                 });
        //                 this.transferBalance('defaultToId');
        //                 this.handleCloseMenu();
        //             }}
        //         >
        //             <ArrowForward sx={{ mr: 2, width: '20px' }}/>
        //             {i18n.t('common.transferBalanceTo')}
        //         </MenuItem>
        //     );
        //     menuItems.push(<Divider key="divider-transf" />);
        // }

        return menuItems;
    }

    handleShowKeys(event) {
        this.setState({
            showKeysDialogOpen: true,
            merchantTerminalId: this.state.menuClickItemId
        });
        this.handleCloseMenu();
        // open keys dialog
    }

    handleShowKeysDialogClose = () => {
        this.setState({
            showKeysDialogOpen: false,
            merchantTerminalId: null
        });
    };

    handleOpenCreatePayment = () => {
        const merchantTerminalId = this.state.menuClickItemId;

        this.setState({
            createTransactionDialogOpen: true,
            createTransactionHead: this.paymentHead,
            createTransactionTitle: 'dialogs.createPayment',
            createTransactionServer: this.Server.createPaymentOrder,
            merchantTerminalId
        });
        this.handleCloseMenu();
    };

    handleOpenCreatePayout = () => {
        const merchantTerminalId = this.state.menuClickItemId;
        this.setState({
            createTransactionDialogOpen: true,
            createTransactionHead: this.payoutHead,
            createTransactionTitle: 'dialogs.createPayout',
            createTransactionServer: this.Server.createPayoutOrder,
            merchantTerminalId
        });
        this.handleCloseMenu();
    };

    handleCloseCreateTransaction = () => {
        this.setState({
            createTransactionDialogOpen: false,
            createTransactionHead: [],
            createTransactionTitle: '',
            createTransactionServer: null
        });
    };

    allowedTransferBalance = () => {
        return this.allowedAction('transfer-balance');
    };
    transferBalance = (directionId) => {
        this.setState({
            transferBalanceDialogOpen: true,
            [directionId]: this.state.menuClickItemId,
            transferBalanceMode: 'default' // 'default' or 'search'
        });
    };
    handleCloseTransferBalanceDialog = () => {
        this.setState(
            {
                transferBalanceDialogOpen: false,
                defaultFromId: null,
                defaultToId: null
            },
            () => this.retrieveData()
        );
    };

    renderCustom() {
        const terminalId = this.state.merchantTerminalId;
        const prefilterRequest = this.fs.getFlatFiltersByGroup('prefilterBase');

        return (
            <>
                <ShowKeysDialog
                    openDialog={this.state.showKeysDialogOpen}
                    server={this.Server}
                    terminalId={terminalId}
                    closeDialog={this.handleShowKeysDialogClose}
                    allowedAction={(action) => this.allowedAction(action)}
                />
                {terminalId && (
                    <CommissionDialog
                        open={this.state.openCommissionsDialog}
                        handleClose={() => this.handleCloseCommissions()}
                        selectedTerminalId={terminalId}
                        terminalsServer={this.Server}
                        commissionsServer={
                            this.props.context.getState().server
                                .publicCommissions
                        }
                    />
                )}
                {this.state.createTransactionDialogOpen && terminalId && (
                    <CreateTransactionDialog
                        dialogOpen={this.state.createTransactionDialogOpen}
                        onClose={this.handleCloseCreateTransaction}
                        Head={this.state.createTransactionHead}
                        server={this.state.createTransactionServer}
                        id={terminalId}
                        dialogTitle={this.state.createTransactionTitle}
                        saveLabel="buttons.save"
                        cancelLabel="buttons.cancel"
                        type={
                            this.state.createTransactionHead ===
                            this.paymentHead
                                ? 'payment'
                                : 'payout'
                        }
                    />
                )}
                {this.allowedTransferBalance() && (
                    <TransferBalanceDialog
                        server={this.Server}
                        open={this.state.transferBalanceDialogOpen}
                        onClose={() => this.handleCloseTransferBalanceDialog()}
                        searchFields={[
                            'name',
                            'merchant.name',
                            'merchantTerminalUuid'
                        ]}
                        // items={this.List || []}
                        // defaultFromId={this.state.defaultFromId}
                        // defaultToId={this.state.defaultToId}
                        // defaultMerchantId={merchantId}
                        // mode={this.state.transferBalanceMode} // 'default' or 'search'

                        prefilterRequest={prefilterRequest}
                    />
                )}
            </>
        );
    }
}
